import styled from '@emotion/styled';

export const HTMLBlockWrapper = styled.div`
  overflow: auto;
  height: 100%;
  width: 100%;
`;
